const MORTGAGE_TAG_TYPES = {
  MORTGAGE_LIST: "MORTGAGE_LIST",
  MORTGAGE_CREATE: "MORTGAGE_CREATE",
  MORTGAGE_DETAIL: "MORTGAGE_DETAIL",
  MORTGAGE_UPDATE_STATUS: "MORTGAGE_UPDATE_STATUS"
} as const;

export const MORTGAGE_TAGS = Object.values(MORTGAGE_TAG_TYPES);
export default MORTGAGE_TAG_TYPES;
